import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobRequestHistoryComponent } from './job-request-history/job-request-history.component';
import { JobRequestHistoryPartnerComponent } from './job-request-history-partner/job-request-history-partner.component';

import { SharedModalService } from './shared-modal.service';
import { SharedModule } from './../shared/shared.module';
import { PackagingHtmlToPdfComponent } from './packaging-html-to-pdf/packaging-html-to-pdf.component';
import { PickUpHtmlToPdfComponent } from './pickup-html-to-pdf/pickup-html-to-pdf.component';
import { RetourHtmlToPdfComponent } from './retour-html-to-pdf/retour-html-to-pdf.component';
import { DriverHtmlToPdfComponent } from './driver-html-to-pdf/driver-html-to-pdf.component';
import { EtatLieuxClientComponent } from './etat-lieux-client/etat-lieux-client.component';
import { JobRequestsGroupQrCodeComponent } from './job-requests-group-qr-code/job-requests-group-qr-code.component';
import { NgxBarcodeModule } from 'ngx-barcode';
import { TransfertHtmlToPDF } from './transfert-html-to-pdf/transfert-html-to-pdf.component';
import { NewSupportTicketComponent } from './new-support-ticket/new-support-ticket.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedHelperService } from './shared-helper.service';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { ConfirmDeleteComponent } from './confirm-delete/confirm-delete.component';

@NgModule({
  declarations: [
    JobRequestHistoryComponent,
    JobRequestHistoryPartnerComponent,
    PackagingHtmlToPdfComponent,
    PickUpHtmlToPdfComponent,
    RetourHtmlToPdfComponent,
    DriverHtmlToPdfComponent,
    EtatLieuxClientComponent,
    JobRequestsGroupQrCodeComponent,
    TransfertHtmlToPDF,
    NewSupportTicketComponent,
    MessageModalComponent,
    ConfirmDeleteComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgxBarcodeModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatDialogModule,
  ],
  providers: [SharedModalService, SharedHelperService],
  exports: [
    JobRequestHistoryComponent,
    JobRequestHistoryPartnerComponent,
    PackagingHtmlToPdfComponent,
    PickUpHtmlToPdfComponent,
    RetourHtmlToPdfComponent,
    DriverHtmlToPdfComponent,
    EtatLieuxClientComponent,
    TransfertHtmlToPDF,
    MessageModalComponent,
  ],
})
export class SharedModalsModule {}
